import { ConfigurationCaseTypeSampleTypeResponse } from '@/modules/configurationModule/detail/local-cases/local-case-types/services/local-case-types.dto'

export interface LocalCasesTypesModalBasicFormSampleTypesState {
    caseTypeSampleTypes: ConfigurationCaseTypeSampleTypeResponse[]
}
export const initialLocalCasesTypesModalBasicFormSampleTypesState =
    (): LocalCasesTypesModalBasicFormSampleTypesState => ({
        caseTypeSampleTypes: []
    })
